import { SubmissionError } from 'redux-form';
import { replace } from 'connected-react-router';

import { SENTIMENT_POLL_ANSWERED } from '../SentimentPoll/actions';

import { cacheFormData } from '../../utils/formCaching/actions';

import { CardTypes } from '../../utils/enums';
import { onWidgetVisibleSalon, onEngagement } from '../../utils/tracking/salonTracking';
import { trackWidgetVisible } from '../../utils/facebookPixel';
import apiSubscribeEmail from '../../utils/widget/subscribeApi';
import apiSaveFormState from '../../utils/widget/formStateApi';

export const ACTION_CHOICE_CANCEL_ACTION = 'ACTION_CHOICE_CANCEL_ACTION';
export const ACTION_CHOICE_OVERLAY_PARTNER_VISIBLE =
    'ACTION_CHOICE_OVERLAY_PARTNER_VISIBLE';
export const ACTION_COMPLETED_LOCAL_REP = 'ACTION_COMPLETED_LOCAL_REP';
export const ACTION_INITIATED = 'ACTION_INITIATED';
export const ACTION_INITIATED_LOCAL_REP = 'ACTION_INITIATED_LOCAL_REP';
export const ACTION_SHARED = 'ACTION_SHARED';
export const ACTION_VISIBLE = 'ACTION_VISIBLE';
export const ADDRESS_VALIDATION_ERROR = 'ADDRESS_VALIDATION_ERROR';
export const EMAIL_COLLECTED = 'EMAIL_COLLECTED';
export const GO_NEXT_ACTION = 'GO_NEXT_ACTION';
export const GO_PREV_ACTION = 'GO_PREV_ACTION';
export const HIDE_NEXT_ACTION_ANIMATION = 'HIDE_NEXT_ACTION_ANIMATION';
export const INCREMENT_NO_CARDS_VISITED = 'INCREMENT_NO_CARDS_VISITED';
export const IS_BACK_TRANSITION = 'IS_BACK_TRANSITION';
export const IS_NEXT_ACTION_TRANSITION = 'IS_NEXT_ACTION_TRANSITION';
export const LINK_INITIATED = 'LINK_INITIATED';
export const ON_BACK_FROM_REP_ACTION = 'ON_BACK_FROM_REP_ACTION';
export const OVERLAY_ELECTION_VISIBLE = 'OVERLAY_ELECTION_VISIBLE';
export const OVERLAY_PARTNER_VISIBLE = 'OVERLAY_PARTNER_VISIBLE';
export const OVERLAY_PUBLISHER_VISIBLE = 'OVERLAY_PUBLISHER_VISIBLE';
export const OVERLAY_REPSTANCE_VISIBLE = 'OVERLAY_REPSTANCE_VISIBLE';
export const OVERLAY_VISIBLE = 'OVERLAY_VISIBLE';
export const OVERLAY_VOTESMART_VISIBLE = 'OVERLAY_VOTESMART_VISIBLE';
export const SET_ACTIVE_ACTION = 'SET_ACTIVE_ACTION';
export const SET_ACTIVE_ACTION_FROM_ACTION_CHOICE =
    'SET_ACTIVE_ACTION_FROM_ACTION_CHOICE';
export const SET_END_USER_ID = 'SET_END_USER_ID';
export const SET_EXITING_PROPS = 'SET_EXITING_PROPS';
export const SET_PARTNER = 'SET_PARTNER';
export const SET_PREVIOUS_ACTION = 'SET_PREVIOUS_ACTION';
export const SET_VISIBLE_REPSTANCE_BY_ID = 'SET_VISIBLE_REPSTANCE_BY_ID';
export const SHARE_DRAWER_VISIBILITY = 'SHARE_DRAWER_VISIBILITY';
export const SHOW_EMAIL_INTERSTITIAL = 'SHOW_EMAIL_INTERSTITIAL';
export const SHOW_NEXT_ACTION_ANIMATION = 'SHOW_NEXT_ACTION_ANIMATION';
export const SUBSCRIBE_SUBMITTING = 'SUBSCRIBE_SUBMITTING';
export const SUBSCRIBE_SUCCESS = 'SUBSCRIBE_SUCCESS';
export const TEXT_COPIED_TO_CLIPBOARD = 'TEXT_COPIED_TO_CLIPBOARD';
export const TWEET_INITIATED = 'TWEET_INITIATED';
export const WIDGET_BOUNCE = 'WIDGET_BOUNCE';
export const WIDGET_BOUNCE_FORM_SUBMITTING = 'WIDGET_BOUNCE_FORM_SUBMITTING';
export const WIDGET_BOUNCE_SUCCESS_ALERT = 'WIDGET_BOUNCE_SUCCESS_ALERT';
export const WIDGET_ENGAGED = 'WIDGET_ENGAGED';
export const WIDGET_LOADED = 'WIDGET_LOADED';
export const WIDGET_RESIZED = 'WIDGET_RESIZED';
export const WIDGET_VISIBLE = 'WIDGET_VISIBLE';

export const setPartner = actionIdentifier => dispatch => {
    dispatch({
        type: SET_PARTNER,
        payload: { actionIdentifier, isFrontCard: false }
    });
};

export const getApiRequestData = (action, state) => {
    if (action == null || state == null) return null;
    return {
        id: action.id,
        actionId: action.actionId,
        articleId: state.widget.apiRequestData.articleId,
        articleUrl: state.widget.apiRequestData.articleUrl,
        widgetId: state.widget.apiRequestData.widgetId,
        partner: action.partner ? action.partner.name : null,
        partnerId: action.partner ? action.partner.id : null,
        publisherId: state.widget.apiRequestData.publisherId,
        publishedDate: state.widget.apiRequestData.publishedDate,
        widgetType: state.widget.apiRequestData.widgetType,
        widgetEmbedType: state.embedType,
        issueId: action.issue ? action.issue.id : null,
        subIssueId: action.subIssue ? action.subIssue.id : null,
        categoryIds: action.categoryIds ? action.categoryIds : [],
        actionOrder: action.order,
        widgetCardId: action.widgetCardId
    };
};

export const actionShared = sharedWith => dispatch => {
    dispatch({
        type: ACTION_SHARED,
        payload: sharedWith
    });

    return true;
};

export const addressValidationError = message => dispatch => {
    dispatch({
        type: ADDRESS_VALIDATION_ERROR,
        payload: message
    });

    setTimeout(() => {
        dispatch({
            type: ADDRESS_VALIDATION_ERROR,
            payload: false
        });
    }, 5000);
};

export const setOverlayVisible = isVisible => dispatch => {
    dispatch({
        type: OVERLAY_VISIBLE,
        payload: isVisible
    });
};

export const setOverlayPublisherVisible = isPublisherVisible => dispatch => {
    dispatch({
        type: OVERLAY_PUBLISHER_VISIBLE,
        payload: isPublisherVisible
    });
};

export const setOverlayRepStanceVisible = (
    isRepStanceVisible,
    voteSmartId
) => dispatch => {
    dispatch({
        type: OVERLAY_REPSTANCE_VISIBLE,
        payload: isRepStanceVisible
    });

    // timeout to prevent content from disappearing
    // within overlay before transition finishes
    setTimeout(
        () => {
            dispatch({
                type: SET_VISIBLE_REPSTANCE_BY_ID,
                payload: voteSmartId
            });
        },
        !isRepStanceVisible ? 300 : 0
    );
};

export const setOverlayPartnerVisible = (
    isPartnerVisible,
    event,
    isRockTheVote,
    isActionChoice,
    isVoteSmart
) => dispatch => {
    if (typeof event !== 'undefined') {
        if ((event.target.id === 'partnerName' || isRockTheVote) && !isActionChoice) {
            dispatch({
                type: OVERLAY_PARTNER_VISIBLE,
                payload: isPartnerVisible
            });
        } else if (event.target.id === 'partnerName' && isActionChoice) {
            dispatch({
                type: ACTION_CHOICE_OVERLAY_PARTNER_VISIBLE,
                payload: isPartnerVisible
            });
        }
    } else {
        if (isActionChoice) {
            dispatch({
                type: ACTION_CHOICE_OVERLAY_PARTNER_VISIBLE,
                payload: isPartnerVisible
            });
        } else {
            dispatch({
                type: OVERLAY_PARTNER_VISIBLE,
                payload: isPartnerVisible
            });
        }
    }

    if (isVoteSmart) {
        dispatch({
            type: OVERLAY_VOTESMART_VISIBLE,
            payload: isPartnerVisible
        });
    }

    if (isRockTheVote) {
        dispatch({
            type: OVERLAY_ELECTION_VISIBLE,
            payload: { isRockTheVote: true }
        });
    } else {
        setTimeout(() => {
            dispatch({
                type: OVERLAY_ELECTION_VISIBLE,
                payload: { isRockTheVote: false }
            });
        }, 400);
    }
};

export const widgetVisible = (widgetId, articleUrl) => dispatch => {
    trackWidgetVisible(widgetId, articleUrl);
    onWidgetVisibleSalon();

    dispatch({
        type: WIDGET_VISIBLE
    });
};

export const saveWidgetFormState = (
    recipientEmail,
    widgetActionId,
    actionType,
    widgetId,
    cachedFormData,
    route,
    savedResultData
) => dispatch => {
    dispatch({
        type: WIDGET_BOUNCE_FORM_SUBMITTING,
        payload: true
    });

    return apiSaveFormState(
        recipientEmail,
        widgetActionId,
        actionType,
        widgetId,
        cachedFormData,
        route,
        savedResultData
    ).then(() => {
        dispatch({
            type: WIDGET_BOUNCE,
            payload: { bool: false, bounceDismissed: true }
        });

        dispatch({
            type: WIDGET_BOUNCE_SUCCESS_ALERT,
            payload: true
        });

        const successTimeout = setTimeout(() => {
            dispatch({
                type: WIDGET_BOUNCE_SUCCESS_ALERT,
                payload: false
            });
            clearTimeout(successTimeout);
        }, 5000);

        const bounceSubmitTimeout = setTimeout(() => {
            dispatch({
                type: WIDGET_BOUNCE_FORM_SUBMITTING,
                payload: false
            });
            clearTimeout(bounceSubmitTimeout);
        }, 750);
    });
};

export const widgetLoaded = () => dispatch =>
    dispatch({ type: WIDGET_LOADED, payload: true });

export const widgetBounce = (
    bool,
    widgetId,
    articleUrl,
    currentFormValues,
    actionIdentifier
) => dispatch => {
    if (!!currentFormValues && !!actionIdentifier) {
        cacheFormData(currentFormValues, actionIdentifier)(dispatch);
    }
    // TODO: ADD TRACKING FOR BOUNCE??
    // trackWidgetBounce(widgetID, articleUrl)
    if (bool === false) {
        dispatch({
            type: WIDGET_BOUNCE,
            payload: { bool, bounceDismissed: !bool }
        });
    } else {
        dispatch({
            type: WIDGET_BOUNCE,
            payload: { bool, bounceDismissed: !bool }
        });
    }
};

export const widgetEngaged = engaged => dispatch => {
    if (!engaged) {
        onEngagement();
        dispatch({
            type: WIDGET_ENGAGED
        });
    }
};

export const resizeWidget = () => dispatch => {
    dispatch({
        type: WIDGET_RESIZED
    });
};

const closeEverything = (dispatch, isMultiActionsCard) => {
    dispatch({
        type: OVERLAY_PUBLISHER_VISIBLE,
        payload: false
    });

    dispatch({
        type: OVERLAY_VOTESMART_VISIBLE,
        payload: false
    });

    dispatch({
        type: OVERLAY_PARTNER_VISIBLE,
        payload: false
    });

    dispatch({
        type: OVERLAY_VISIBLE,
        payload: false
    });

    dispatch({
        type: SHARE_DRAWER_VISIBILITY,
        payload: false
    });

    if (isMultiActionsCard) {
        var dataActionVisible = document.querySelectorAll('[data-action]');
        for (var i = 0; i < dataActionVisible.length; i++) {
            dataActionVisible[i].disabled = true;
        }
    }
};

export const onFinishMultiAction = actionIdentifier => dispatch => {
    dispatch({
        type: SET_PARTNER,
        payload: { actionIdentifier, isFrontCard: true }
    });

    dispatch(replace('/multiActionsCard'));
};

export const rightToLeftAnim = dispatch => {
    dispatch({
        type: SHOW_NEXT_ACTION_ANIMATION
    });

    dispatch({
        type: IS_NEXT_ACTION_TRANSITION,
        payload: true
    });
};

const bottomToTopAnim = dispatch => {
    dispatch({
        type: SHOW_NEXT_ACTION_ANIMATION
    });

    dispatch({
        type: IS_NEXT_ACTION_TRANSITION,
        payload: false
    });
};

export const onGoToNextActionInsideCard = (
    actionIdentifier,
    type,
    isMultiActionsCard,
    isActionChoiceCard
) => dispatch => {
    closeEverything(dispatch, isMultiActionsCard);

    rightToLeftAnim(dispatch);

    dispatch({
        type: GO_NEXT_ACTION,
        payload: { actionIdentifier }
    });

    dispatch({
        type: SET_PARTNER,
        payload: { actionIdentifier, isFrontCard: false }
    });

    if (isActionChoiceCard) {
        dispatch(replace(`/${type}/start`));
    } else {
        dispatch(replace(`/${type}`));
    }

    if (!isMultiActionsCard) {
        setTimeout(() => {
            dispatch({
                type: ACTION_INITIATED_LOCAL_REP,
                payload: actionIdentifier
            });
        }, 1000);
    }
};

export const setPreviousCard = actionIdentifier => dispatch => {
    dispatch({
        type: SET_PREVIOUS_ACTION,
        payload: actionIdentifier
    });
};

export const goToPrevAction = ({ identifier, type }) => dispatch => {
    closeEverything(dispatch, false);
    dispatch({
        type: GO_PREV_ACTION,
        payload: { actionIdentifier: identifier }
    });
    dispatch({
        type: SET_PARTNER,
        payload: { actionIdentifier: identifier, isFrontCard: false }
    });
    dispatch(replace(`/${type}/start`));
};

export const onGoToNextCard = (
    actionIdentifier,
    cardType,
    actionType,
    skipFrontCardOnNextAction,
    isSameAction // if this transistion doesn't represent a new action (for preloader)
) => dispatch => {
    closeEverything(dispatch, cardType === CardTypes.multipleActions);

    bottomToTopAnim(dispatch);

    dispatch({
        type: INCREMENT_NO_CARDS_VISITED
    });

    dispatch({
        type: SET_PARTNER,
        payload: { actionIdentifier, isFrontCard: true }
    });

    dispatch({
        type: GO_NEXT_ACTION,
        payload: { actionIdentifier }
    });

    if (cardType === CardTypes.multipleActions || cardType === CardTypes.multiDonation) {
        dispatch(replace(`/multiActionsCard`));
    } else if (cardType === CardTypes.targetedMultiAction) {
        dispatch(replace(`/targetedMultiAction`));
    } else if (cardType === CardTypes.actionChoice) {
        dispatch(replace(`/actionChoiceCard`));
    } else if (skipFrontCardOnNextAction) {
        dispatch(replace(`/${actionType}`));
    } else {
        dispatch(replace(`/${actionType}/start`));
    }

    setTimeout(() => {
        rightToLeftAnim(dispatch);
        if (!isSameAction) {
            setTimeout(() => {
                dispatch({
                    type: ACTION_VISIBLE
                });
            }, 800);
        }
    }, 800);
};

export const setExitingCardProps = (type, props, activeAction) => dispatch => {
    dispatch({ type: SET_EXITING_PROPS, payload: { type, props, activeAction } });
};

export const getExitingCardProps = (type, allowedPaths, location, state) => {
    if (location === state.router.location.pathname) {
        return;
    }
    if (allowedPaths.find(ap => ap.toLowerCase() === location.toLowerCase())) {
        const props = (state.widget.exitingProps || {})[type];
        if (props && props.location.pathname === location) {
            return props;
        }
    }
};

export const onBackWithinCard = (
    actionIdentifier,
    card,
    useBackTransition
) => dispatch => {
    if (useBackTransition) {
        dispatch({
            type: IS_BACK_TRANSITION,
            payload: true
        });
    }
    dispatch({
        type: SET_PARTNER,
        payload: { actionIdentifier, isFrontCard: true }
    });

    if (card.type === CardTypes.oneAction) {
        const action = card.actions[0];
        dispatch(replace(`/${action.type}/start`));
    } else if (
        card.type === CardTypes.multipleActions ||
        card.type === CardTypes.multiDonation
    ) {
        dispatch(replace(`/multiActionsCard`));
    } else if (card.type === CardTypes.targetedMultiAction) {
        dispatch(replace(`/targetedMultiAction`));
    } else if (card.type === CardTypes.actionChoice) {
        dispatch({ type: ACTION_CHOICE_CANCEL_ACTION });
        dispatch(replace(`/actionChoiceCard`));
    }

    dispatch({
        type: ON_BACK_FROM_REP_ACTION,
        payload: actionIdentifier
    });

    setTimeout(() => {
        dispatch({
            type: IS_BACK_TRANSITION,
            payload: false
        });
    }, 750);
};

export const onSubscribeComplete = (
    values,
    activeActionType,
    collectEmailFor,
    isMultiActionsCard,
    skipNavigatingToSuccessPage = false,
    callback = null
) => dispatch => {
    dispatch({
        type: SUBSCRIBE_SUBMITTING,
        payload: true
    });

    return apiSubscribeEmail(values, collectEmailFor)
        .then(() => {
            setTimeout(() => {
                dispatch({
                    type: EMAIL_COLLECTED,
                    payload: true
                });

                dispatch({
                    type: SUBSCRIBE_SUCCESS,
                    payload: true
                });

                if (typeof callback === 'function') {
                    callback();
                }

                dispatch({
                    type: SUBSCRIBE_SUBMITTING,
                    payload: false
                });

                if (activeActionType) {
                    dispatch({
                        type: SHOW_EMAIL_INTERSTITIAL,
                        payload: false
                    });

                    if (isMultiActionsCard) {
                        dispatch(replace(`/multiActionsCard`));
                    } else if (skipNavigatingToSuccessPage) {
                        if (activeActionType === 'sentimentpoll') {
                            dispatch({ type: SENTIMENT_POLL_ANSWERED });
                        }
                        return;
                    } else if (isMultiActionsCard === false) {
                        dispatch(replace(`/${activeActionType}/success`));
                    }

                    setTimeout(() => {
                        dispatch({
                            type: OVERLAY_VISIBLE,
                            payload: false
                        });
                    }, 3000);
                }
            }, 800);
        })
        .catch(reason => {
            dispatch({
                type: SUBSCRIBE_SUBMITTING,
                payload: false
            });

            throw new SubmissionError({
                _error: reason.message,
                email: "Couldn't submit form, try again later"
            });
        });
};

export const openShareDrawer = () => dispatch => {
    dispatch({
        type: SHARE_DRAWER_VISIBILITY,
        payload: true
    });
};

export const closeShareDrawer = () => dispatch => {
    dispatch({
        type: SHARE_DRAWER_VISIBILITY,
        payload: false
    });
};

export const copyToClipboard = () => dispatch => {
    dispatch({
        type: TEXT_COPIED_TO_CLIPBOARD,
        payload: true
    });
};

export const onShowEmailInterstitial = () => dispatch => {
    dispatch({
        type: SHOW_EMAIL_INTERSTITIAL,
        payload: true
    });
};

export const skipInterstitialPopup = (
    activeActionType,
    isMultiActionsCard,
    skipNavigatingToSuccessPage = false
) => dispatch => {
    setTimeout(() => {
        dispatch({
            type: SHOW_EMAIL_INTERSTITIAL,
            payload: false
        });

        if (isMultiActionsCard) {
            dispatch(replace(`/multiActionsCard`));
        } else if (skipNavigatingToSuccessPage) {
            if (activeActionType === 'sentimentpoll') {
                dispatch({ type: SENTIMENT_POLL_ANSWERED });
            }
        } else {
            dispatch(replace(`/${activeActionType}/success`));
        }
    }, 100);
};
